import { Card, CardContent, CardMedia, Grid, Menu, MenuItem, Tab, Tabs, Typography } from "@mui/material"
import styles from "../../Styles/ComponentStyles/TrainingPageStyles/Training.module.scss"
import { TrainingContext, TrainingContextPayload } from "../../Context/TrainingPageContext"
import { useContext, useEffect, useRef, useState, useMemo, useCallback, memo } from "react"
import { UserContext, UserContextPayload } from "../../Context/UserDetailContext"
import { GetCompanyResourceDataResponse } from "../../Models/axiosModel"
import pdfIcon from "../../assets/Images/Training/pdfIcon.svg"
import MoreVertIcon from '@mui/icons-material/MoreVert';
import GlobalPopUp from "../../GlobalComponent/GlobalPopup/GlobalPopup"
import AddNewResource, { CreateNewResourcePayload } from "../../GlobalComponent/AddNewResource/AddNewResource"
import ResourceViewComponent from "../../GlobalComponent/ResourceViewComponent/ResourceViewComponent"
import GlobalDeletePopup from "../../GlobalComponent/GlobalDeletePopup/GlobalDeletePopup"
import { useSnackbar } from "../../GlobalComponent/GlobalSnackbar/GlobalSnackbar"
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

const Training = () => {

    const {
        getCompanyResourceData,
        uploadResource,
        deleteResource,
        setLinearShow,
        setIsUploading,
        createNewResource,
        selectedResorceData,
        setSelectedResorceData,
        isEditModeTrainingPage,
        setIsEditModeTrainingPage,
        updateResource,
        flagOpenAddNewResourceDialog,
        setFlagOpenAddNewResourceDialog,
    } = useContext(TrainingContext) as TrainingContextPayload
    const { setFlagLoader } = useContext(UserContext) as UserContextPayload;
    const [companyResourceData, setCompanyResourceData] = useState<GetCompanyResourceDataResponse[]>([])
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [flagOpenResourceViewPopup, setFlagOpenResourceViewPopup] = useState(false)
    const [flagOpenDeleteResourcePopup, setFlagOpenDeleteResourcePopup] = useState(false)
    const [tabValue, setTabValue] = useState<"Video" | "Document">("Video")
    const [activeTab, setActiveTab] = useState<number>(0)

    const { showSnackbar } = useSnackbar()
    const openMenu = Boolean(anchorEl);

    useEffect(() => {
        const fetchData = async () => {
            setFlagLoader(true);
            try {
                await fetchCompanyResourceData();
            } catch (error) {
                console.log(error, "Something Went Wrong!");
            } finally {
                setFlagLoader(false);
            }
        };
        fetchData();
    }, []);


    const fetchCompanyResourceData = async () => {
        setFlagLoader(true)
        const response = await getCompanyResourceData();
        if (response?.status) {
            const data = response?.data || [];
            setCompanyResourceData(data);
            setFlagLoader(false)
        } else {
            setFlagLoader(false)
            console.log("Someting Went Wrong!")
        }
    }

    const handleDeleteResource = async () => {
        try {
            setFlagLoader(true);
            const response = await deleteResource(selectedResorceData?.resource_id);
            if (response?.status) {
                await fetchCompanyResourceData();
                setFlagOpenDeleteResourcePopup(false)
                setFlagLoader(false);
                showSnackbar("Resource Deleted Successfully!", "success")
            } else {
                setFlagOpenDeleteResourcePopup(false);
                setFlagLoader(false);
                showSnackbar(response?.error?.message || "Error deleting  resource!", "error")
            }
        } catch (error) {
            console.error('Error deleting resource:', error);
        } finally {
            setFlagLoader(false);
        }
    };

    const uploadResourceAPIFunc = async (e: any, resource_flag_to_send: any) => {
        setLinearShow(true)
        const file = e.target.files[0];
        if (!file) {
            console.error("No file selected.");
            setLinearShow(false)
            return;
        }
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('resource_flag', resource_flag_to_send);

        try {
            setIsUploading(true);
            const response = await uploadResource(formData);
            if (response?.status && response?.data) {
                if (resource_flag_to_send == 'true') {
                    setSelectedResorceData({
                        ...selectedResorceData,
                        resource_file_id: response?.data['resource_file_id'],
                        resource_file_name: file.name,
                    });
                    setLinearShow(false)
                } else {
                    setSelectedResorceData({
                        ...selectedResorceData,
                        thumbnail_file_id: response?.data['thumbnail_file_id'],
                        thumbnail_file_name: file.name,
                    });
                    setLinearShow(false)
                }
            } else {
                showSnackbar(response?.error?.message || "Error uploading file!", "error")
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            setLinearShow(false)
        } finally {
            setIsUploading(false);
            setLinearShow(false)
        }
    };

    const handleCreateResourceSubmit = async () => {
        try {
            if (!selectedResorceData.resource_title ||
                !selectedResorceData.resource_description ||
                (!selectedResorceData?.resource_coming_soon && !selectedResorceData.resource_file_id) ||
                !selectedResorceData.thumbnail_file_id) {
                showSnackbar("Please enter all the fields!", "error")
                return
            }

            const payload: CreateNewResourcePayload = {
                resource_title: selectedResorceData.resource_title,
                resource_description: selectedResorceData.resource_description,
                resource_file_id: selectedResorceData.resource_file_id,
                thumbnail_file_id: selectedResorceData.thumbnail_file_id,
                resource_coming_soon: selectedResorceData.resource_coming_soon || false,
                resource_file_type: tabValue
            }

            setFlagLoader(true)
            const response = await createNewResource(payload)

            if (response?.status) {
                await fetchCompanyResourceData()
                setFlagOpenAddNewResourceDialog(false);
                setSelectedResorceData({})
                showSnackbar("Resource Created Successfully!", "success")
            } else {
                showSnackbar("Error Uploading Resource!", "error")
            }
        } catch (error) {
            console.log(error, "Something went wrong!")
            showSnackbar("An error occurred", "error")
        } finally {
            setFlagLoader(false)
        }
    }
    const handleUpdateResourceSubmit = async () => {
        try {
            const effectiveResourceFileId =
                selectedResorceData?.resource_file_id ?? selectedResorceData?.resource_file_data?.[0]?.file_id;
            const effectiveThumbnailFileId =
                selectedResorceData?.thumbnail_file_id ?? selectedResorceData?.resource_file_data?.[1]?.thumbnail_id;

            if (!selectedResorceData.resource_title ||
                !selectedResorceData.resource_description ||
                (!selectedResorceData?.resource_coming_soon && !effectiveResourceFileId) ||
                !effectiveThumbnailFileId) {
                showSnackbar("Please enter all the fields!", "error")
                return
            }
            const payload = {
                resource_id: selectedResorceData?.resource_id,
                resource_title: selectedResorceData?.resource_title,
                resource_description: selectedResorceData?.resource_description,
                resource_file_id: effectiveResourceFileId,
                thumbnail_file_id: effectiveThumbnailFileId,
                resource_coming_soon: selectedResorceData.resource_coming_soon,
                resource_file_type: tabValue
            }
            setFlagLoader(true)
            const response = await updateResource(payload);
            if (response?.status) {
                await fetchCompanyResourceData()
                setFlagOpenAddNewResourceDialog(false);
                setSelectedResorceData({})
                showSnackbar("Resource Updated Successfully!", "success")
            } else {
                showSnackbar("Error Updating Data!", "error")
            }
        } catch (error) {
            setFlagLoader(false)
            console.log(error, "Something went wrong!")
        } finally {
            setFlagLoader(false)
        }
    }

    const DescriptionWithToggle = memo(({ description }: { description: string }) => {
        const textRef = useRef<HTMLSpanElement>(null);
        const [expanded, setExpanded] = useState(false);
        const [isOverflowing, setIsOverflowing] = useState(false);
        const prevDescriptionRef = useRef<string>(description);

        useEffect(() => {
            if (prevDescriptionRef.current !== description) {
                prevDescriptionRef.current = description;
                setExpanded(false);
            }

            const checkOverflow = () => {
                if (textRef.current) {
                    const el = textRef.current;
                    if (!expanded) {
                        const hasOverflow = el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
                        setIsOverflowing(hasOverflow);
                    } else {
                        setIsOverflowing(true);
                    }
                }
            };

            const rafId = requestAnimationFrame(() => {
                checkOverflow();
            });

            window.addEventListener("resize", checkOverflow);

            return () => {
                cancelAnimationFrame(rafId);
                window.removeEventListener("resize", checkOverflow);
            };
        }, [description, expanded]);

        return (
            <>
                <Typography
                    ref={textRef}
                    component="span"
                    className={`${styles.cardDescription} ${expanded ? styles.cardDescriptionExpanded : ""}`}
                >
                    {description}
                </Typography>
                {isOverflowing && (
                    <div
                        className={styles.viewMoreButton}
                        onClick={() => setExpanded(prev => !prev)}
                    >
                        {expanded ? "View less" : "View more"}
                    </div>
                )}
            </>
        );
    });

    DescriptionWithToggle.displayName = 'DescriptionWithToggle';

    const handleOpenTrainingMenuCallback = useCallback((event: React.MouseEvent<HTMLElement | SVGSVGElement>, resource: GetCompanyResourceDataResponse) => {
        event.stopPropagation();
        setSelectedResorceData(JSON.parse(JSON.stringify(resource)));
        setAnchorEl(event.currentTarget as HTMLElement);
    }, []);

    const handleCloseTrainingMenuCallback = useCallback(() => {
        setAnchorEl(null);
    }, []);

    const renderResourceCard = useCallback((resource: GetCompanyResourceDataResponse) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={resource.resource_id}>
            <Card className={styles.resourceCard}>
                <CardMedia
                    component="img"
                    image={resource?.resource_file_data[1]?.thumbnail_url}
                    alt={`${resource.resource_title} thumbnail`}
                    className={styles.cardMedia}
                    onClick={() => {
                        setSelectedResorceData(resource)
                        setFlagOpenResourceViewPopup(true)
                    }}
                />
                <CardContent className={styles.cardContentRoot}>
                    <Grid container alignItems="flex-start" justifyContent="space-between" wrap="nowrap">
                        <Grid item xs>
                            <Grid container alignItems="center" gap="5px" wrap="nowrap">
                                {resource?.resource_file_data?.[0]?.file_type === "pdf" && (
                                    <Grid item className={styles.pdfIconWrapper}>
                                        <img src={pdfIcon} alt="PDF icon" className={styles.pdfIcon} />
                                    </Grid>
                                )}
                                <Grid item xs>
                                    <Typography component="span" className={styles.cardTitle}>
                                        {resource.resource_title}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item className={styles.menuIconWrapper}>
                            <MoreVertIcon
                                className={styles.moreVertIcon}
                                onClick={(e) => handleOpenTrainingMenuCallback(e, resource)}
                            />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            <DescriptionWithToggle description={resource.resource_description} />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    ), [handleOpenTrainingMenuCallback]);

    const videoResources = useMemo(() =>
        companyResourceData?.filter(
            resource =>
                resource?.resource_file_type === "Video" &&
                !resource?.resource_coming_soon
        ) || [],
        [companyResourceData]
    );

    const documentResources = useMemo(() =>
        companyResourceData?.filter(
            resource =>
                resource?.resource_file_type === "Document" &&
                !resource?.resource_coming_soon
        ) || [],
        [companyResourceData]
    );

    const comingSoonResources = useMemo(() =>
        companyResourceData?.filter(
            resource => resource?.resource_coming_soon
        ) || [],
        [companyResourceData]
    );

    const getActiveResources = () => {
        switch (activeTab) {
            case 0: return videoResources;
            case 1: return documentResources;
            case 2: return comingSoonResources;
            default: return videoResources;
        }
    };

    const getEmptyMessage = () => {
        switch (activeTab) {
            case 0: return "No videos added yet.";
            case 1: return "No documents added yet.";
            case 2: return "No resource added in coming soon yet.";
            default: return "No resources found.";
        }
    };

    const activeResources = getActiveResources();

    return (
        <>
            {flagOpenAddNewResourceDialog &&
                <GlobalPopUp
                    maxWidth={"sm"}
                    open={flagOpenAddNewResourceDialog}
                    onClose={() => {
                        setFlagOpenAddNewResourceDialog(false);
                        setSelectedResorceData({})
                    }}
                    title={isEditModeTrainingPage ? "Update Resource" : "Add New Resource"}
                    showCloseIcon={true}
                    flagDivider
                    spacing={0}
                >
                    <AddNewResource
                        onClose={() => {
                            setFlagOpenAddNewResourceDialog(false);
                            setSelectedResorceData({})
                        }}
                        uploadResourceAPIFunc={uploadResourceAPIFunc}
                        onSubmit={isEditModeTrainingPage ? handleUpdateResourceSubmit : handleCreateResourceSubmit}
                        isEditModeTrainingPage={isEditModeTrainingPage}
                        setIsEditModeTrainingPage={setIsEditModeTrainingPage}
                        tabValue={tabValue}
                        setTabValue={setTabValue}
                    />
                </GlobalPopUp>
            }
            {flagOpenResourceViewPopup &&
                <GlobalPopUp
                    open={flagOpenResourceViewPopup}
                    onClose={() => { setFlagOpenResourceViewPopup(false) }}
                    title={selectedResorceData?.resource_title}
                    showCloseIcon={true}
                    flagDivider
                    maxWidth={"lg"}
                >
                    <ResourceViewComponent selectedResourceData={selectedResorceData} />
                </GlobalPopUp>
            }
            {flagOpenDeleteResourcePopup && (
                <GlobalPopUp
                    open={flagOpenDeleteResourcePopup}
                    onClose={() => {
                        setFlagOpenDeleteResourcePopup(false);
                    }}
                    maxWidth={"sm"}
                    title="Delete Resource"
                >
                    <GlobalDeletePopup
                        popupDescription={`Are you sure you want to delete this resource`}
                        handleClose={() => {
                            setFlagOpenDeleteResourcePopup(false);
                        }}
                        onDelete={handleDeleteResource}
                    />
                </GlobalPopUp>
            )}

            <Grid container>
                <Grid item xs={12} className={styles.trainingPageWrapper}>
                    <Grid container className={styles.globalBlurWrapper}>

                        {/* Tabs */}
                        <Grid item xs={12}>
                            <Tabs
                                value={activeTab}
                                onChange={(_e, newVal) => setActiveTab(newVal)}
                                className={styles.trainingTabs}
                                TabIndicatorProps={{ className: styles.tabIndicator }}
                            >
                                <Tab label="Videos" className={styles.trainingTab} />
                                <Tab label="Documents" className={styles.trainingTab} />
                                <Tab label="Coming Soon" className={styles.trainingTab} />
                            </Tabs>
                        </Grid>

                        {/* Tab Content */}
                        <Grid item xs={12} className={styles.tabContent}>
                            {activeResources.length > 0 ? (
                                <Grid container spacing={3}>
                                    {activeResources.map(renderResourceCard)}
                                </Grid>
                            ) : (
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Typography component="span" className={styles.noDataYetTxt}>
                                            {getEmptyMessage()}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>

            {/* Single shared Menu */}
            <Menu
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleCloseTrainingMenuCallback}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                PaperProps={{
                    style: {
                        backgroundColor: "#fff",
                        borderRadius: "7px",
                    },
                }}
            >
                {/* <MenuItem
                    sx={{ color: '#ffffff', '&:hover': { backgroundColor: 'white', color: '#105EA7' } }}
                    onClick={() => setAnchorEl(null)}
                >
                    <span>Assign to Agent</span>
                </MenuItem> */}
                <MenuItem
                    sx={{ color: '#314158', '&:hover': { backgroundColor: 'white', color: '#105EA7' } }}
                    onClick={() => {
                        setIsEditModeTrainingPage(true)
                        setFlagOpenAddNewResourceDialog(true)
                        setAnchorEl(null)
                    }}
                >
                    <ModeEditOutlineOutlinedIcon fontSize="small" />&nbsp;<span>Edit</span>
                </MenuItem>
                <MenuItem
                    sx={{ color: '#314158', '&:hover': { backgroundColor: 'white', color: '#105EA7' } }}
                    onClick={() => {
                        setFlagOpenDeleteResourcePopup(true)
                        setAnchorEl(null)
                    }}
                >
                    <DeleteForeverOutlinedIcon fontSize="small" />
                    &nbsp;
                    <span>Delete</span>
                </MenuItem>
            </Menu>
        </>
    )
}

export default Training